export function groupByCount<T>(array: T[], count: number): T[][] {
    return [...Array(Math.ceil(array.length / count))].map((_, index) => array.slice(index * count, (index + 1) * count));
}
